
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { CommunicationLogEntryModel } from 'models/generated/Communication.Api.Models.CommunicationLogEntry';


const _communication_CommunicationControllerHelper = new Map<string, Object>();
_communication_CommunicationControllerHelper.set('GetLogEntry', CommunicationLogEntryModel);
_communication_CommunicationControllerHelper.set('GetLogEntriesForCompany', CommunicationLogEntryModel);
_communication_CommunicationControllerHelper.set('GetLogEntriesForTaskflow', CommunicationLogEntryModel);
_communication_CommunicationControllerHelper.set('UpdateCommunicationLogEntry', CommunicationLogEntryModel);
_communication_CommunicationControllerHelper.set('AddCommunicationLogEntry', CommunicationLogEntryModel);
_communication_CommunicationControllerHelper.set('SendMail', CommunicationLogEntryModel);


export const communication_CommunicationControllerHelper = _communication_CommunicationControllerHelper;

